export const LOGIN_USER = 'LOGIN_USER';

export const RECEIVE_CURRENCY_API_SUCCESS = 'RECEIVE_CURRENCY_API_SUCCESS';
export const RECEIVE_EXPENSES_API_SUCCESS = 'RECEIVE_EXPENSES_API_SUCCESS';

export const RECEIVE_API_FAILURE = 'RECEIVE_CURRENCY_API_FAILURE';
export const REQUEST_API = 'REQUEST_API';
export const DELETE_EXPENSE = 'DELETE_EXPENSE';
export const EDIT_EXPENSE = 'EDIT_EXPENSE';
export const UPDATE_EDITED_EXPENSE = 'UPDATE_EDITED_EXPENSE';
